fx.ns("models", class Text extends fx.Model {

	constructor(data)
	{
        super(data);
    }


    get defaults()
    {
        return { thumb: "" };
    }
    
    get propertiesNotStorable()
    {
        return ["thumb"];
    }

    get localized()
    {
        return true;
    }

    saveThumb(thumb)
    {
        this.post("/app/texts", {   action : "update", 
                                    id : this.id, 
                                    theme_tag_id : this.theme_tag_id,
                                    product_id : this.product_id,
                                    id_lang : this.id_lang,
                                    thumb : thumb,
                                }, this.onThumbSaved)
    }

    onThumbSaved(data)
    {
        if (data.error)
            this.event("text-save-error");
        else
        {
            this.prop("oldid", this.id);

            this.update(data); // updates thumb and id
            this.event("text-saved");
        } 
            
    }


    loadLang(id_lang)
    {
        this.post({ url : "/app/texts", action : "lang", id : this.id, id_lang : id_lang}, this._langLoaded)
    }

    _langLoaded(data)
    {
        if (data.error)
            this.event("load_lang_error");
        else
        {
            this.content = data.content;
            this.id_lang = data.id_lang;
            this.event("lang-loaded");
        }
    }
});
		